import { Typography } from '@mui/material';
import React from 'react';
import { toast } from 'react-toastify';
import { useFetch } from 'src/hooks/useFetch';
import { createMessageError } from 'src/utils/messaggeError';
import { Modal } from '..';

const Contrasenia = (props) => {
  const { open, close: onClose } = props;
  const { fetch } = useFetch();

  const onCloseModal = React.useCallback(() => {
    onClose();
  }, [onClose]);
  const confirmHandler = async () => {
    fetch(`/usuarios/${props.data.id}/enviar-correo-actualizar-contrasena`, {
      method: 'POST',
    })
      .then(() => {
        toast.success(
          'Cambio realizado con éxito, en breve le llegara un correo al usuario. ',
        );
        onClose();
      })
      .catch((e) => {
        const message = createMessageError(e.message);
        console.log(e);
        toast.error(message);
        onClose();
      });
  };
  /*   const formik = useFormik({
    initialValues: {
      password: '',
      repeatPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required('La contraseña es obligatoria')
        .oneOf([Yup.ref('repeatPassword')], 'Las contraseñas no son iguales'),
      repeatPassword: Yup.string()
        .required('La contraseña es obligatoria')
        .oneOf([Yup.ref('password')], 'Las contraseñas no son iguales'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        Reflect.deleteProperty(values, 'repeatPassword');
        await fetch(`/usuarios/${props.data.id}`, {
          method: 'PATCH',
          data: { ...values },
        });
        toast.success('Contraseña modificada con exito');
        resetForm();
        onClose();
      } catch (error) {
        toast.error('No se ha podido modificar contraseña');
        console.error(error);
        resetForm();
      }
    },
  }); */
  return (
    <Modal
      title={'Resetear Contraseña'}
      open={open}
      content={
        <>
          <Typography>¿Estás seguro de efectuar este cambio? </Typography>
        </>
      }
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default Contrasenia;
